module.exports = __webpack_public_path__ + "static/media/soehne-web-dreiviertelfett.67aadfe2.woff2";